document.body.addEventListener("click", (e) => {
  const dropdown = document.querySelector('[data-block="dropdown"]');

  if (dropdown) {
    if (dropdown?.contains(e.target)) {
      dropdown.classList.toggle("open");
    } else if (dropdown?.contains(e.target)) {
      dropdown.classList.add("open");
    }

    if (!dropdown?.contains(e.target)) {
      dropdown.classList.remove("open");
    }
  }
});
